
import React, { useEffect, useState } from "react"
import "./OrganizationScreenFixedCostItemsOptionsTable.css"
import { useDispatch, useSelector } from "react-redux";
import { Organization } from "../../../FirebaseModel/Organization";
import { Role } from "../../../FirebaseModel/Role";
import OrganizationScreenRolesRow, { OrganizationScreenRolesRowProps } from "../OrganizationScreenRolesRow/OrganizationScreenRolesRow";
import DraggableTableBody from "../../DraggableTableBody/DraggableTableBody";
import { saveRoleAttributeChange } from "../../../Utils/SaveRoleFunctions";
import { saveOrganizationAttributeChange } from "../../../Utils/SaveOrganizationFunctions";
import { bindActionCreators } from "redux";
import ActionCreators from "../../../Redux/ActionCreators";
import { faBars, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface OrganizationScreenFixedCostItemsOptionsTableProps{
}

let optionsTableTimeout:NodeJS.Timeout|null=null;

export default function OrganizationScreenFixedCostItemsOptionsTable(props:OrganizationScreenFixedCostItemsOptionsTableProps){

  const organizationID = useSelector((state:{organizationID:string}) => state.organizationID)
  const organization = useSelector((state:{organization:Organization}) => state.organization)
  const permissionsWrite = useSelector((state:{permissionsWrite:string[]}) => state.permissionsWrite)

  const dispatch = useDispatch();
  const AC = bindActionCreators({
    setRoles:ActionCreators.setRoles,
		submitUndoStackEntry:ActionCreators.submitUndoStackEntry},dispatch);

	const [fixedCostItemsList, setFixedCostItemsList] = useState<string[]>([... organization.fixedCostItemsList]);
	
	const [savingOptionsReorder, setSavingOptionsReorder] = useState(false);
	
	useEffect(() =>{
		setSavingOptionsReorder(false);
		setFixedCostItemsList([... organization.fixedCostItemsList]);
	},[organization,organization.fixedCostItemsList]);
	
	
  return (
    <table 
			className={`OrganizationScreenFixedCostItemsOptionsTable`}>
			{savingOptionsReorder == false && (
				<>
					<thead>
						<tr>
							<th>Option Name</th>
						</tr>
					</thead>
					<DraggableTableBody
						childClassName=""
						keyForIndex={(index:number) =>{
							return `${fixedCostItemsList[index]}`;
						}}
						orderedItems={organization.fixedCostItemsList}
						onOrderUpdated={(newOrder:string[]) =>{
						}}
						onOrderUpdateEnded={(newOrder:string[]) =>{
							setFixedCostItemsList(newOrder);
							saveOrganizationAttributeChange(organization,"fixedCostItemsList",newOrder,(entry) =>{
								AC.submitUndoStackEntry(entry);
							});
						}}>
						{organization.fixedCostItemsList.map((option:string, index) =>{
							return <>
								{permissionsWrite.includes("Organization") ? (
									<tr key={`${option}`}>
										<td><FontAwesomeIcon icon={faBars} style={{pointerEvents:"none", fontSize:"50%"}}></FontAwesomeIcon></td>
										<td>
											<input type='text' onChange={(e) =>{
												const newOptions = [...organization.fixedCostItemsList];
												newOptions[index] = e.target.value;
												if(optionsTableTimeout != null){
													clearTimeout(optionsTableTimeout);
													optionsTableTimeout = null;
												}
												optionsTableTimeout = setTimeout(() =>{
													setFixedCostItemsList(newOptions);
													saveOrganizationAttributeChange(organization,"fixedCostItemsList",newOptions,(entry) =>{
														AC.submitUndoStackEntry(entry);
													});
												},1000);
											}} defaultValue={fixedCostItemsList[index]}></input>
										</td>
										<div className="buttonDelete"
											onClick={() =>{
												if(window.confirm("Are you sure you'd like to delete this option?")){
													const newOptions = [...organization.fixedCostItemsList];
													newOptions.splice(index,1)
													if(optionsTableTimeout != null){
														clearTimeout(optionsTableTimeout);
														optionsTableTimeout = null;
													}
													setSavingOptionsReorder(true);
													optionsTableTimeout = setTimeout(() =>{
														setFixedCostItemsList(newOptions);
														saveOrganizationAttributeChange(organization,"fixedCostItemsList",newOptions,(entry) =>{
															AC.submitUndoStackEntry(entry);
														});
													},1000);
												}
											}}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></div>
									</tr>
								):(
									<tr key={`${option}_${index}`}>
											<td></td>
											<td>
												{fixedCostItemsList[index]}
											</td>
										</tr>
								)}
							</>
						})}
					</DraggableTableBody>
				</>
			)}
    </table>
  )
}